<div class="pagecontent">
    <div class="appointment-content" formGroupName="tripRequest">
        @for (date of appointmentDatesFr.controls; track date; let i = $index) {
            <div formArrayName="tripAppointments">   
                <div [formGroupName]="i" >
                    <div class="trip-appointment-date-container">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                    at {{ date.get('appointmentTime')?.value | date: 'shortTime'}}
                                </mat-panel-title>
                                <mat-panel-description>
                                    Do you want to see a breakdown of your trip per legs? View Breakdown
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="legs-container">
                                @for (leg of getAppointmentLegs(i).controls; track leg; let j = $index) {
                                    <div formArrayName="tripLegs">  
                                        <div [formGroupName]="j">
                                            <div class="leg-container-address-row">
                                                <div class="address-form-field control-flex-1">
                                                    <label [for]="'legAddressCategory'+i+'-'+j">Address Category</label>
                                                    <mat-form-field appearance="outline" class="disabled-field">
                                                        <input [id]="'legAddressCategory'+i+'-'+j" matInput [value]="getAddressCategory(j) | async" readonly />
                                                    </mat-form-field>
                                                </div>
                                                <div class="address-form-field control-flex-2">
                                                    <label [for]="'legAddress'+i+'-'+j">{{getAddressTitle(j)}}</label>
                                                    <mat-form-field appearance="outline" class="disabled-field">
                                                        <input [id]="'legAddress'+i+'-'+j" matInput [value]="getAddress(j)" readonly />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="leg-container-miles-row">
                                                <div class="form-field">
                                                    <label [for]="'shortMiles'+i+'-'+j">Shortest Calculated Miles</label>
                                                    <mat-form-field appearance="outline" class="disabled-field">
                                                        <input [id]="'shortMiles'+i+'-'+j" formControlName="shortestMiles" matInput readonly />
                                                    </mat-form-field>
                                                </div>
                                                @if(tripRequest.get('tripType')?.value === 'Post') {
                                                    <div class="form-field">
                                                        <label [for]="'enteredMiles'+i+'-'+j">Consumer Entered Miles</label>
                                                        <mat-form-field appearance="outline" >
                                                            <input [id]="'enteredMiles'+i+'-'+j" formControlName="enteredMiles" matInput [errorStateMatcher]="matcher" (input)="onMilesEntered(i)" integerOnly />
                                                            @if (hasError(`tripAppointments.${i}.tripLegs.${j}.enteredMiles`, 'required')) {
                                                                <mat-error>This field is required.</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="form-field">
                                                        <label [for]="'approvedMiles'+i+'-'+j">Agency Approved Miles</label>
                                                        <mat-form-field appearance="outline" class="disabled-field">
                                                            <input [id]="'approvedMiles'+i+'-'+j" formControlName="approvedMiles" matInput readonly/>
                                                        </mat-form-field>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="leg-container-address-row">
                                    <div class="address-form-field control-flex-1">
                                        <label [for]="'destinationAddressCategory'+i">Address Category</label>
                                        <mat-form-field appearance="outline" class="disabled-field">
                                            <input [id]="'destinationAddressCategory'+i" matInput [value]="getAddressCategory(tripRequest.get('isRoundTrip')?.value ? 0: addressFr.length-1) | async" readonly="true" />
                                        </mat-form-field>
                                    </div>
                                    <div class="address-form-field control-flex-2">
                                        <label [for]="'destinationAddress'+i">Destination</label>
                                        <mat-form-field appearance="outline" class="disabled-field">
                                            <input [id]="'destinationAddress'+i" matInput [value]="getAddress(tripRequest.get('isRoundTrip')?.value ? 0: addressFr.length-1)" readonly="true" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            @if (tripRequest.get('tripType')?.value === "Post" && date.get('showExplanationText')?.value) {
                                <div class="explanation-row">
                                    <div class="form-field">
                                        <label [id]="'explanationLabel'+i" [for]="'explanationText'+i">Please enter explanation on why your miles are different <span class="star">*</span></label>
                                        <mat-form-field appearance="outline" aria-labelledby="explanation-label">
                                            <textarea
                                                [id]="'explanationText'+i"
                                                [attr.aria-labelledby]="'explanationLabel'+i"
                                                matInput
                                                formControlName="explanationText"
                                                name="explanation"
                                                rows="3"
                                                maxlength="1000"
                                                placeholder="Enter Explanation"
                                                [errorStateMatcher]="matcher">
                                            </textarea>
                                            @if (hasError(`tripAppointments.${i}.explanationText`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>
                            }
                            
                        </mat-expansion-panel>
                    </div>
                    <div class="mileage-container">
                        <span class="span-font-weight">Mileage Reimbursement</span>
                        <div class="table-container">
                            <table role="presentation">
                                <caption class="cdk-visually-hidden">Mileage Reimbursement</caption>
                                <thead>
                                    <tr class="table-cell-background" role="row">
                                        <th scope="col"></th>
                                        <th scope="col">Requested</th>
                                        <th scope="col">Approved</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Total Miles</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            <span>{{ date.get('totalMiles')?.value | number: '1.0-0'}}</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ 0 }}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Mileage Reimbursement Amount</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ date.get('totalMileageAmount')?.value | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ 0.00 | currency }}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Parking</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ getExpenseAmount(i, 'Parking') | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell"> 
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ 0.00 | currency }}</span>
                                            }
                                        </td>
                                    </tr> 
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Tolls</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ getExpenseAmount(i, 'Toll') | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ 0.00 | currency}}</span>
                                            }
                                        </td>
                                    </tr> 
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Total Reimbursement</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ getTotalAmount(i) | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripRequest.get('tripType')?.value === 'Post') {
                                                <span>{{ 0.00 | currency}}</span>
                                            }
                                        </td>
                                    </tr>
                                </tbody>                                                                  
                            </table>
                        </div>
                    </div>                   
                </div>
            </div>
        }
         @if (appointmentDatesFr.length > 1) {
            <div class="mileage-container">
                <span class="span-font-weight">Total Mileage Reimbursement</span>
                <div class="table-container">
                    <table role="presentation">
                        <caption class="cdk-visually-hidden">Total Mileage Reimbursement</caption>
                        <thead>
                            <tr class="table-cell-background" role="row">
                                <th scope="col"></th>
                                <th scope="col">Requested</th>
                                <th scope="col">Approved</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Total Miles</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    <span>{{ getTripTotalMailes() | number: '1.0-0'}}</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ 0 }}</span>
                                    }
                                </td>
                            </tr>
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Mileage Reimbursement Amount</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ getTripTotalMileageAmount() | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ 0.00 | currency }}</span>
                                    }
                                </td>
                            </tr>
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Parking</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ getTripExpenseAmount('Parking') | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell"> 
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ 0.00 | currency }}</span>
                                    }
                                </td>
                            </tr> 
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Tolls</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ getTripExpenseAmount('Toll') | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ 0.00 | currency}}</span>
                                    }
                                </td>
                            </tr> 
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Total Reimbursement</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ getTripTotalAmount() | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripRequest.get('tripType')?.value === 'Post') {
                                        <span>{{ 0.00 | currency}}</span>
                                    }
                                </td>
                            </tr> 
                        </tbody>                                                                 
                    </table>
                </div>
            </div> 
        }
        <div class="consent-container">
            <div class="checkbox-container">
                <mat-checkbox class="options-checkbox-margin" formControlName="tripAuthorize" aria-label="The Consumer Attestation">Confirmed The Consumer Attestation was signed</mat-checkbox>
            </div>
            @if (hasError(`tripAuthorize`, 'required')) {
                <span class="error-text-format">This field is required</span>
            }
        </div>
        <div class="radio-container">
            <fieldset class="radio-fieldset" aria-label="Select review option">
                <mat-radio-group formControlName="isSameAgentWillReview">
                    <mat-radio-button [value]='true' aria-label="I will review this trip request">I will review</mat-radio-button>
                    <mat-radio-button [value]='false' aria-label="Someone else will review this trip request">Someone else will review</mat-radio-button>
                </mat-radio-group>
            </fieldset>
        </div>
    </div>
</div>